import React, { useEffect, useState, useRef } from 'react';
import { Tooltip, Input, Button, Select, DatePicker, Tag } from 'antd';
import DataTable from 'react-data-table-component';
import { CSVLink } from 'react-csv';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import { USER_BLOCK_LOG_ALL } from './../../../Utils/appConstants';
import { getRequest } from './../../../Utils/AppApi';
import { ToastContainer, toast } from 'react-toastify';
import { getUser, kycStatusValue } from './../../../Utils/Common';
import { getUTCToLocalDateFormat } from './../../../Utils/function';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;

function BlockLogHistory() {
    const user = getUser();
    const history = useHistory();
    const csvLink = useRef();
    const dateFormat = 'DD-MM-YYYY';

    const [getData, setData]               = useState([]);
    const [getCsvData, setCsvData]         = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage]                  = useState(1);
    const [isLimit, setLimit]              = useState(10);

    const [action, setAction]              = useState("");
    const [searchInput, setSearchInput]    = useState("");
    const [search, setSearch]              = useState("");
    const [startDate, setStartDate]        = useState(null);
    const [endDate, setEndDate]            = useState(null);
    const [dateRange, setDateRange]        = useState(null);

    const columns = [
        {
            name: 'Action',
            cell: row => (
                row.action === 'block'
                    ? <Tag color="red" style={{ fontWeight: 600 }}>BLOCKED</Tag>
                    : <Tag color="green" style={{ fontWeight: 600 }}>UNBLOCKED</Tag>
            ),
            width: "120px"
        },
        {
            name: 'User Id',
            selector: row => (
                <Tooltip placement="bottom" title={row.targetUser?.username || "—"}>
                    {row.targetUser?.username || "—"}
                </Tooltip>
            ),
            width: "130px"
        },
        {
            name: 'User Name',
            selector: row => (
                <Tooltip placement="bottom" title={row.targetUser?.name || "—"}>
                    {row.targetUser?.name || "—"}
                </Tooltip>
            ),
            width: "150px"
        },
        {
            name: 'User Mobile',
            selector: row => row.targetUser?.mobile || "—",
            width: "120px"
        },
        // {
        //     name: 'User Type',
        //     selector: row => row.targetRole?.name || "—",
        //     width: "120px"
        // },
        {
            name: 'KYC',
            cell: row => <>{kycStatusValue(row.targetUser?.KYCStatus)}</>,
            width: "110px"
        },
        {
            name: 'Parent Id',
            selector: row => (
                <Tooltip placement="bottom" title={row.parentUser?.username || "—"}>
                    {row.parentUser?.username || "—"}
                </Tooltip>
            ),
            width: "130px"
        },
        {
            name: 'Parent Name',
            selector: row => (
                <Tooltip placement="bottom" title={row.parentUser?.name || "—"}>
                    {row.parentUser?.name || "—"}
                </Tooltip>
            ),
            width: "150px"
        },
        // {
        //     name: 'Parent Type',
        //     selector: row => row.parentRole?.name || "—",
        //     width: "120px"
        // },
        {
            name: 'Action By',
            selector: row => row.actionByName || "—",
            width: "130px"
        },
        {
            name: 'Date',
            cell: row => getUTCToLocalDateFormat(row.createdAt),
            width: "150px"
        },
        {
            name: 'Remark',
            selector: row => (
                <Tooltip placement="bottom" title={row.remark || ""}>
                    <span style={{ color: row.remark ? '#1A1A2E' : '#9CA3AF' }}>
                        {row.remark || "—"}
                    </span>
                </Tooltip>
            ),
            grow: 2,
            minWidth: "200px"
        }
    ];

    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj)
            if (obj.hasOwnProperty(p) && obj[p] !== "" && obj[p] !== null && obj[p] !== undefined) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const getDataReports = (newLimit) => {
        const params = { page: page, limit: isLimit };
        if (newLimit) {
            params.limit = newLimit;
            setLimit(newLimit);
        }
        if (action) params.action = action;
        if (search) params.search = search;
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;

        const queryString = objectToQueryString(params);
        getRequest(`${USER_BLOCK_LOG_ALL}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const getCSVDataList = () => {
        const csvParams = { page: 1, limit: 10000 };
        if (action) csvParams.action = action;
        if (search) csvParams.search = search;
        if (startDate) csvParams.startDate = startDate;
        if (endDate) csvParams.endDate = endDate;

        const queryString = objectToQueryString(csvParams);
        getRequest(`${USER_BLOCK_LOG_ALL}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                const rows = [];
                (response.data.docs || []).forEach((e) => {
                    rows.push({
                        "Action": e.action === 'block' ? "Blocked" : "Unblocked",
                        "User Id": e.targetUser?.username || "",
                        "User Name": e.targetUser?.name || "",
                        "User Mobile": e.targetUser?.mobile || "",
                        "User Type": e.targetRole?.name || "",
                        "KYC": kycStatusValue(e.targetUser?.KYCStatus),
                        "Parent Id": e.parentUser?.username || "",
                        "Parent Name": e.parentUser?.name || "",
                        "Parent Type": e.parentRole?.name || "",
                        "Action By": e.actionByName || "",
                        "Date": getUTCToLocalDateFormat(e.createdAt),
                        "Remark": e.remark || ""
                    });
                });
                setCsvData(rows);
                setTimeout(() => csvLink.current.link.click(), 1000);
            } else {
                setCsvData([]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const handleSearch = () => {
        setSearch(searchInput);
        setPage(1);
    };

    const handleClear = () => {
        setAction("");
        setSearchInput("");
        setSearch("");
        setStartDate(null);
        setEndDate(null);
        setDateRange(null);
        setPage(1);
    };

    const onChangeDatePickerValue = (dates, dateStrings) => {
        setStartDate(dateStrings[0] || null);
        setEndDate(dateStrings[1] || null);
        if (dateStrings && dateStrings[0]) {
            setDateRange([
                moment(dateStrings[0], "DD-MM-YYYY"),
                moment(dateStrings[1], "DD-MM-YYYY")
            ]);
        } else {
            setDateRange(null);
        }
    };

    useEffect(() => {
        getDataReports();
    }, [page, action, search, startDate, endDate]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className="container-fluid pt-2 pb-5">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid mb-3 ml-2">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>
                                    Block / Unblock <span className='text-red'>Log</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className='float-sm-right d-flex mb-1'>
                        <button
                            type="button"
                            className="btn btn-primary mr-3"
                            onClick={() => getCSVDataList()}
                        >
                            <i className="fa fa-file-excel"></i> Export
                        </button>
                        <CSVLink
                            data={getCsvData}
                            filename='block-log-history.csv'
                            className='hidden'
                            ref={csvLink}
                            target='_blank'
                        />
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-2">
                            <label className='form-label'>Action</label>
                            <Select
                                className='w-100'
                                placeholder="All"
                                value={action || undefined}
                                onChange={(v) => { setAction(v || ""); setPage(1); }}
                                allowClear
                            >
                                <Option value="block">Block</Option>
                                <Option value="unblock">Unblock</Option>
                            </Select>
                        </div>
                        <div className="col-md-3">
                            <label className='form-label'>Date Range</label>
                            <RangePicker
                                format={dateFormat}
                                allowClear
                                onChange={onChangeDatePickerValue}
                                className="w-100"
                                value={dateRange}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className='form-label'>Search</label>
                            <Input
                                placeholder="Search by user or parent (username / name)"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onPressEnter={handleSearch}
                                allowClear
                            />
                        </div>
                        <div className="col-md-3">
                            <label className='form-label'>&nbsp;</label>
                            <div>
                                <Button type="primary" onClick={handleSearch}>Search</Button>
                                <Button type="default" onClick={handleClear} className='ml-2'>Clear</Button>
                            </div>
                        </div>
                    </div>

                    <div className="box-body">
                        <DataTable
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            striped
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={(p) => setPage(p)}
                            noDataComponent={
                                <div className='text-center text-muted py-4'>
                                    No log entries found.
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                limit={2}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
}

export default BlockLogHistory;